import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Link as RouterLink } from "react-router-dom";
import {
  PLAN_LIMIT_UPGRADE_PATH,
} from "../../utils/billingApi";

export default function UpgradePrompt({
  open,
  onClose,
  title = "Upgrade your plan",
  upgradeUrl = PLAN_LIMIT_UPGRADE_PATH,
  confirmLabel = "Upgrade plan",
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: "16px", mx: 2 } }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 1,
          pr: 1.5,
          pt: 2.5,
          pb: 0.5,
        }}
      >
        <Typography
          component="span"
          sx={{ fontWeight: 700, fontSize: "18px", color: "#0f172a", lineHeight: 1.4 }}
        >
          {title}
        </Typography>
        <IconButton
          onClick={onClose}
          aria-label="Close"
          size="small"
          sx={{ color: "#64748b", mt: -0.5 }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogActions sx={{ px: 3, pb: 2.5, pt: 1, gap: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            textTransform: "none",
            fontWeight: 600,
            color: "#0f172a",
            borderColor: "#cbd5e1",
            borderRadius: "10px",
          }}
        >
          Not now
        </Button>
        <Button
          component={RouterLink}
          to={upgradeUrl}
          onClick={onClose}
          variant="contained"
          color="primary"
          sx={{ textTransform: "none", fontWeight: 600, borderRadius: "10px" }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
